// components/ChatMessage.tsx
import React, { memo } from 'react';
import { MessageFactory } from './messages/MessageFactory';
import { MessageComponentProps, FeedbackConfig } from '../types/messageTypes';
import './SQLStatement.css';

type ChatMessageProps = MessageComponentProps & {
  feedbackConfig?: FeedbackConfig;
};

const ChatMessage: React.FC<ChatMessageProps> = memo(
  ({
    message,
    executeSQLStatement,
    handleSubmitWrapper,
    setPromptId,
    setSqlQuery,
    feedbackConfig,
  }) => {
    return (
      <MessageFactory
        message={message}
        executeSQLStatement={executeSQLStatement}
        handleSubmitWrapper={handleSubmitWrapper}
        setPromptId={setPromptId}
        setSqlQuery={setSqlQuery}
        feedbackConfig={feedbackConfig}
      />
    );
  }
);

export default ChatMessage;
